import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { 
  Button, 
  Typography, 
  TextField, 
  InputAdornment, 
  Menu, 
  MenuItem, 
  Card, 
  CardMedia, 
  CardContent, 
  CardActions,
  Grid,
  Container,
  Box,
  Chip
} from "@mui/material";
import { SearchRounded, FilterListRounded } from "@mui/icons-material";
import placeholder from "./placeholder.png";
import SpinnerLoading from "../spinner/SpinnerLoading";
import "./libraryList.scss";
import {
  collection,
  getDocs,
  limit,
  orderBy,
  query,
  startAfter,
  where,
} from "firebase/firestore";
import { db } from "../../firebase";

var queryConditon = orderBy("publish_on", "desc");

function LibraryList({ type }) {
  let dataValue;
  switch (type) {
    case "books":
      dataValue = {
        collectionVal: collection(db, "eLibrary"),
        emptyMessage:
          "No books found yet. Start adding some to build your library.",
        redirectVal: "library",
      };
      break;
    case "pending":
      dataValue = {
        collectionVal: collection(db, "pendingBooks"),
        emptyMessage:
          "No books found yet to approve. Start adding some to build your library.",
        redirectVal: "pending-books",
      };
      break;
    default:
      break;
  }

  const [Listofbooks, setListofbooks] = useState([]);
  const [lastKey, setLastKey] = useState();
  const [isLoading, setLoading] = useState(false);
  const [isEmpty, setEmpty] = useState(false);
  const [searchValue, setSearchVallue] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const [currentSort, setCurrentSort] = useState("Most Recent");

  const navigate = useNavigate();

  useEffect(() => {
    const queryRef = query(dataValue.collectionVal, queryConditon, limit(18));
    getDocs(queryRef).then((querySnapshot) => {
      updateState(querySnapshot);
    });
  }, []);

  const updateState = (collections) => {
    const isCollectionEmpty = collections.size === 0;
    if (!isCollectionEmpty) {
      const books = collections.docs.map((book) => {
        const data = book.data();
        return { id: book.id, ...data };
      });
      const Lastdoc = collections.docs[collections.docs.length - 1];
      setListofbooks((Listofbooks) => [...Listofbooks, ...books]);
      setLastKey(Lastdoc);

      if (collections.size < 18) {
        setEmpty(true);
      }
    } else {
      setEmpty(true);
    }
    setLoading(false);
  };

  const fetchMorePosts = () => {
    setLoading(true);
    setEmpty(false);

    console.log(queryConditon);

    const queryRefAfter = query(
      dataValue.collectionVal,
      queryConditon,
      startAfter(lastKey),
      limit(18)
    );
    getDocs(queryRefAfter).then((querySnapshot) => {
      updateState(querySnapshot);
    });
  };
  const fetchSearchData = () => {
    setEmpty(false);
    const queryRefAfter = query(
      dataValue.collectionVal,
      queryConditon,
      limit(18)
    );
    getDocs(queryRefAfter).then((querySnapshot) => {
      updateState(querySnapshot);
    });
  };
  const onSearchClick = () => {
    const value = searchValue;
    if (value.length === 0) {
    } else {
      queryConditon = where("searchKeywords", "array-contains", value);
      setListofbooks([]);
      fetchSearchData();
    }
  };
  const handleSearchInput = (e) => {
    if (e.target.value.length === 0) {
      queryConditon = orderBy("publish_on", "desc");
      setListofbooks([]);
      fetchSearchData();
    }
    setSearchVallue(e.target.value);
  };

  const onSort = (value, label) => {
    queryConditon = value;
    setCurrentSort(label);
    setListofbooks([]);
    fetchSearchData();
    setAnchorEl(null);
  };

  const handleFilterClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleFilterClose = () => {
    setAnchorEl(null);
  };

  return (
    <Container maxWidth="xl" className="parent">
      {type === "books" && (
        <Box className="topNavBar" sx={{ mb: 3 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <Typography variant="h5" sx={{ fontWeight: 600, color: '#333' }}>
              Library
            </Typography>
            <Chip 
              label={`${Listofbooks.length} books`} 
              size="small" 
              color="primary" 
              variant="outlined"
            />
          </Box>

          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <TextField
              size="small"
              placeholder="Search books..."
              value={searchValue}
              onChange={handleSearchInput}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchRounded />
                  </InputAdornment>
                ),
              }}
              sx={{ minWidth: 250 }}
            />
            <Button
              variant="contained"
              onClick={onSearchClick}
              sx={{ px: 3 }}
            >
              Search
            </Button>
            <Button
              variant="outlined"
              startIcon={<FilterListRounded />}
              onClick={handleFilterClick}
              sx={{ px: 3 }}
            >
              {currentSort}
            </Button>
            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleFilterClose}
            >
              <MenuItem onClick={() => onSort(orderBy("publish_on", "desc"), "Most Recent")}>
                Most Recent
              </MenuItem>
              <MenuItem onClick={() => onSort(orderBy("name", "asc"), "Alphabetical A-Z")}>
                Alphabetical A-Z
              </MenuItem>
              <MenuItem onClick={() => onSort(orderBy("price", "asc"), "Price: Low to High")}>
                Price: Low to High
              </MenuItem>
              <MenuItem onClick={() => onSort(orderBy("price", "desc"), "Price: High to Low")}>
                Price: High to Low
              </MenuItem>
            </Menu>
          </Box>
        </Box>
      )}

      {Listofbooks.length === 0 && !isEmpty && (
        <Box sx={{ display: 'flex', justifyContent: 'center', py: 8 }}>
          <SpinnerLoading />
        </Box>
      )}
      
      {Listofbooks.length === 0 && isEmpty && (
        <Box className="centerErrorMessage">
          <Typography variant="h6" color="text.secondary" align="center">
            {dataValue.emptyMessage}
          </Typography>
        </Box>
      )}
      
      {Listofbooks.length !== 0 && (
        <Box>
          <Grid container spacing={3}>
            {Listofbooks.map((item, index) => (
              <Grid item xs={12} sm={6} md={4} lg={3} xl={2} key={index}>
                <Card 
                  sx={{ 
                    height: '100%', 
                    display: 'flex', 
                    flexDirection: 'column',
                    transition: 'transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out',
                    '&:hover': {
                      transform: 'translateY(-4px)',
                      boxShadow: 4
                    }
                  }}
                >
                  <Box sx={{ position: 'relative', paddingTop: '150%' }}>
                    <CardMedia
                      component="img"
                      image={placeholder}
                      alt="Placeholder"
                      sx={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover'
                      }}
                    />
                    <CardMedia
                      component="img"
                      image={item.thumbImage}
                      alt={item.name}
                      onLoad={(e) => {
                        e.target.style.opacity = 1;
                        const placeholderImg = e.target.previousSibling;
                        if (placeholderImg) {
                          placeholderImg.style.display = 'none';
                        }
                      }}
                      sx={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        opacity: 0,
                        transition: 'opacity 0.5s ease-in-out'
                      }}
                    />
                  </Box>
                  
                  <CardContent sx={{ flexGrow: 1, p: 2 }}>
                    <Typography 
                      variant="h6" 
                      component="h3"
                      sx={{
                        fontSize: '1rem',
                        fontWeight: 600,
                        mb: 1,
                        display: '-webkit-box',
                        WebkitBoxOrient: 'vertical',
                        overflow: 'hidden',
                        WebkitLineClamp: 2,
                        lineHeight: 1.3
                      }}
                    >
                      {item.name}
                    </Typography>
                    
                    <Typography 
                      variant="body2" 
                      color="text.secondary"
                      sx={{
                        display: '-webkit-box',
                        WebkitBoxOrient: 'vertical',
                        overflow: 'hidden',
                        WebkitLineClamp: 2,
                        mb: 1
                      }}
                    >
                      {item.about}
                    </Typography>
                    
                    {item.price && (
                      <Typography variant="body2" color="primary" sx={{ fontWeight: 600 }}>
                        ₹{item.price}
                      </Typography>
                    )}
                  </CardContent>
                  
                  <CardActions sx={{ p: 2, pt: 0 }}>
                    <Button
                      variant="contained"
                      fullWidth
                      href={"/" + dataValue.redirectVal + "/" + item.id}
                      target="_blank"
                      sx={{ 
                        textTransform: 'none',
                        fontWeight: 600
                      }}
                    >
                      View Ebook
                    </Button>
                  </CardActions>
                </Card>
              </Grid>
            ))}
          </Grid>
          
          {isLoading && (
            <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
              <SpinnerLoading />
            </Box>
          )}
          
          <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
            {!isLoading && !isEmpty && (
              <Button
                variant="contained"
                onClick={fetchMorePosts}
                size="large"
                sx={{ px: 4, py: 1.5 }}
              >
                Load More eBooks
              </Button>
            )}
          </Box>
        </Box>
      )}
    </Container>
  );
}

export default LibraryList;
